import script from "./LocaleSwitcher.vue?vue&type=script&lang=ts&setup=true"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=ts&setup=true"

import "./LocaleSwitcher.vue?vue&type=style&index=0&id=374b14b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-374b14b4"]])

export default __exports__